import {
  makeStyles,
  MenuItem,
  MenuItemProps,
  mergeClasses,
} from "@fluentui/react-components";

interface MenuItemCustomProps {
  rcName?: string;
  theme?: string;
}

const useStyles = makeStyles({
  root: {
    paddingTop: "8px",
    paddingBottom: "8px",
    "&.active": {
      backgroundColor: "var(--colorNeutralBackground1Selected)",
    },
  },
});

const MenuItemCustom = (props: MenuItemCustomProps & MenuItemProps) => {
  const styles = useStyles();
  return (
    <MenuItem
      {...props}
      className={mergeClasses(styles.root, props.className)}
    />
  );
};

export default MenuItemCustom;
